import React from 'react';
import { ornamentStyles } from '../data/gallery';
import { SectionHeading } from './ui/SectionHeading';
import { BuyButton } from './ui/BuyButton';
export function Styles() {
  return <section className="w-full bg-cream py-14 sm:py-20 lg:py-24" data-id="element-182" data-mp="30axgoxn35la7">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-183" data-mp="30afku24c592t">
        <SectionHeading overline="8 estilos para crear" title={<>
              Descubre todo lo que puedes crear{' '}
              <span className="italic text-terracotta-500" data-id="element-185" data-mp="27n1lxyh2u3g2">
                con tus propias manos
              </span>
            </>} data-id="element-184" data-mp="2vbumy9ck31hj" />

        <ul className="mt-9 grid grid-cols-2 gap-3 sm:mt-12 sm:gap-5 lg:grid-cols-4" data-id="element-186" data-mp="22lm1a7it9yy7">
          {ornamentStyles.map(style => <li key={style.name} className="group flex flex-col overflow-hidden rounded-2xl border border-gold-200/60 bg-bone sm:rounded-3xl" data-id="element-187" data-mp="2clwfnvgl1cey">
              <img src={style.image} alt={style.name} loading="lazy" className="aspect-square w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.04] sm:aspect-[4/5]" data-id="element-188" data-mp="1ouqx38j9c60y" />
              <div className="flex flex-1 flex-col px-3.5 py-3.5 sm:px-5 sm:py-4" data-id="element-189" data-mp="aaw5lpz5ap1p">
                <h3 className="font-serif text-[1.05rem] leading-tight text-sage-800 sm:text-[1.35rem]" data-id="element-190" data-mp="ebxwnjiwrusl">
                  {style.name}
                </h3>
                <p className="mt-1 text-[11.5px] leading-snug text-ink-light sm:mt-1.5 sm:text-[13px]" data-id="element-191" data-mp="o2ss9ei1o6qp">
                  {style.caption}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mt-9 flex justify-center sm:mt-12" data-id="element-192" data-mp="3rj9cyj3j10t1">
          <BuyButton size="lg" label="Quiero crear mis esferas" href="#oferta" className="w-full sm:w-auto" data-id="element-193" data-mp="3rjswu5cqlz9p" />
        </div>
      </div>
    </section>;
}